import type { QueriesResponse } from '@empathybroker/tsclient-stats/dist/models/queries/queries.response'
import type { QueriesTypeEnum } from '../../../enums'
import type { AnalyticsState, MutationClass } from '../../../models'
import Vue from 'vue'

export class SetQueriesDataMutation implements MutationClass {
  static execute(
    this: void,
    state: AnalyticsState,
    payload: { data: QueriesResponse; queriesType: QueriesTypeEnum },
  ): void {
    if (!state.data.queries[payload.queriesType]) {
      Vue.set(state.data.queries, payload.queriesType, payload.data)
    } else {
      state.data.queries[payload.queriesType] = payload.data
    }
  }
}
